
import { defineComponent } from "vue";
import SvgIcon from "@/components/SvgIcon.vue";
import { ICONS } from "@/data/constants";

export default defineComponent({
  name: "PlayButton",

  components: {
    SvgIcon,
  },

  data() {
    return {
      ICONS,
    };
  },

  props: {
    size: {
      type: Number,
    },
  },

  methods: {},
});
